import { render, staticRenderFns } from "./QuickTagger.vue?vue&type=template&id=9ff1776e&"
import script from "./QuickTagger.vue?vue&type=script&lang=js&"
export * from "./QuickTagger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports